export default __webpack_public_path__ + "static/media/bike.43bd0bc8.svg";